module.exports = __webpack_public_path__ + "img/background_c4-2-2_mobile.046474a4.jpg";